export const bannerTypes = {
  MODAL_VIEW_IMG_VISIBLE: "MODAL_VIEW_IMG_VISIBLE",
  GET_BANNER_LIST: "GET_BANNER_LIST",
  GET_BANNER_IMGS: 'GET_BANNER_IMGS'
}